import {
  SET_SHOP_COUNTERS, RECALCULATE_ARRANGEMENTS_COUNT, RECALCULATE_LESSONS_COUNT,
  RECALCULATE_MODERATOR_ARRANGEMENTS_COUNT, RECALCULATE_MODERATOR_LESSONS_COUNT,
  SET_SHOP_TAGS, SET_SHOP_COMPOSERS, SET_SHOP_PERFORMERS, SET_SHOP_FILMS,
  SET_SHOP_DIFFICULTIES, SET_SHOP_TONALITIES,
  SET_OFFERS_FORM_INFO,
  SET_OFFERS_LIST,
  SET_MODER_OFFERS_LIST,
  REMOVE_OFFER, CREATE_OFFER,
  SET_OFFER_FOR_UPDATE, SET_UPDATED_FILES, SET_HIDE_DELETE_FILES_ACTIONS,
  CLEAR_INITIAL_VALUES, CLEAR_UPDATED_FILES, CLEAR_HIDE_DELETE_FILES_ACTIONS,
  UPDATE_OFFER, UPDATE_OFFER_PARTIAL, UPDATE_MODERATOR_OFFER_PARTIAL,
} from '../constants/shop';

const initialState = {
  arrangements_count: 0,
  lessons_count: 0,
  arrangements_moder_count: 0,
  lessons_moder_count: 0,

  composerOptions: [],
  performerOptions: [],
  filmOptions: [],
  tags: [],

  initialValues: { agree_promotion: true },
  updatedFiles: [],
  hideDeleteFileActions: false,
  formInfo: null,

  list: [],
  moderList: [],
};

const shopReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHOP_COUNTERS:
      return { ...state, ...action.data };
    case RECALCULATE_ARRANGEMENTS_COUNT:
      return {
        ...state,
        arrangements_count: state.list.filter(i => !i.checked).length
      };
    case RECALCULATE_LESSONS_COUNT:
      return {
        ...state,
        lessons_count: state.list.filter(i => !i.checked).length
      };
    case RECALCULATE_MODERATOR_ARRANGEMENTS_COUNT:
      return {
        ...state,
        arrangements_moder_count: state.list.filter(i => !i.checked).length
      };
    case RECALCULATE_MODERATOR_LESSONS_COUNT:
      return {
        ...state,
        lessons_moder_count: state.list.filter(i => !i.checked).length
      };

    case SET_SHOP_TAGS:
      return {
        ...state,
        tags: [...action.list]
      };
    case SET_SHOP_DIFFICULTIES:
      return {
        ...state,
        difficulties: action.list
      };
    case SET_SHOP_TONALITIES:
      return {
        ...state,
        tonalities: action.list
      };
    case SET_SHOP_COMPOSERS:
      return {
        ...state,
        composerOptions: action.list.map(i => ({ value: i.id, label: i.name }))
      };
    case SET_SHOP_PERFORMERS:
      return {
        ...state,
        performerOptions: action.list.map(i => ({ value: i.id, label: i.name }))
      };
    case SET_SHOP_FILMS:
      return {
        ...state,
        filmOptions: action.list.map(i => ({ value: i.id, label: i.name }))
      };

    case SET_OFFERS_FORM_INFO:
      return {
        ...state,
        formInfo: action.data
      };

    case CLEAR_INITIAL_VALUES:
      return {
        ...state,
        initialValues: { agree_promotion: true, price: 0 },
      };
    case CLEAR_UPDATED_FILES:
      return {
        ...state,
        updatedFiles: [],
      };
    case CLEAR_HIDE_DELETE_FILES_ACTIONS:
      return {
        ...state,
        hideDeleteFileActions: false,
      };

    case SET_OFFERS_LIST:
      return {
        ...state,
        list: action.list.map( o => { o.status=o.checked ? 1 : 2; return o; } ),
      };

    case SET_MODER_OFFERS_LIST:
      return {
        ...state,
        moderList: action.list,
      };

    case REMOVE_OFFER:
      return {
        ...state,
        list: state.list.filter(o => o.id !== action.id),
      };

    case CREATE_OFFER:
      return {
        ...state,
        list: [action.item].concat(state.list),
      };

    case SET_OFFER_FOR_UPDATE:
      return {
        ...state,
        initialValues: action.data,
      };
    case SET_UPDATED_FILES:
      return {
        ...state,
        updatedFiles: action.list,
      };
    case SET_HIDE_DELETE_FILES_ACTIONS:
      return {
        ...state,
        hideDeleteFileActions: action.value,
      };

    case UPDATE_OFFER:
      const updatedOffer = action.item;
      return {
        ...state,
        list: state.list.map(i => {
          if (i.id === updatedOffer.id) {
            return {...updatedOffer}
          }
          return i;
        })
      };

    case UPDATE_OFFER_PARTIAL:
      const updatedData = action.item;
      return {
        ...state,
        list: state.list.map(i => {
          if (i.id === updatedData.id) {
            return {...i, ...updatedData}
          }
          return i;
        })
      };

    case UPDATE_MODERATOR_OFFER_PARTIAL:
      const updatedModeratorData = action.item;
      return {
        ...state,
        moderList: state.moderList.map(i => {
          if (i.id === updatedModeratorData.id) {
            return {...i, ...updatedModeratorData}
          }
          return i;
        })
      };



    default:
      return state;
  }
};

export default shopReducer;